const FooterLangTextA: any = {
    us: {
        email_title: 'Join now for 5% off and $1,000+ exclusive coupons!',
    },
    global: {
        email_title: 'Follow us for the latest news and updates.',
        select_country: 'Select your country or region:',
    },
    // 2
    ca: {
        email_title: 'Join now for 5% off and $1,000+ exclusive coupons!',
    },
    eu: {
        email_title: 'Join now for 5% off and latest deals.',
    },
    uk: {
        email_title: 'Join now for 5% off and latest deals.',
    },
    de: {
        email_title: 'Jetzt anmelden und 5 % Rabatt sowie aktuelle Angebote sichern.',
    },
    fr: {
        email_title: 'Inscrivez-vous pour profiter de 5 % de réduction et des dernières offres.',
    },
    it: {
        email_title: 'Iscriviti ora per ottenere il 5% di sconto e le ultime offerte.',
    },
    es: {
        email_title: 'Únete ahora para obtener un 5 % de descuento y las últimas ofertas.',
    },
    nl: {
        PrivacyPolicy: 'Privacybeleid',
        TermsOfUse: 'Gebruiksvoorwaarden',
        email_title: 'Meld je nu aan voor 5% korting en de nieuwste aanbiedingen.',
        email_desc: '',
        select_country: 'Selecteer uw land of regio:',
        privacyTerms: [
            {
                text: 'Gebruiksvoorwaarden',
                link: 'https://account.ecoflow.com/agreement/nl-nl/TermsOfUse.html',
            },
            {
                text: 'Privacybeleid',
                link: 'https://account.ecoflow.com/agreement/nl-nl/PrivacyPolicy.html',
            },
            {
                text: 'Garantiebeleid',
                link: 'https://nl.ecoflow.com/pages/warranty-policy',
            },
            {
                text: 'Gegevensbeveiliging en Privacy',
                link: 'https://www.ecoflow.com/nl/data-security-and-privacy',
            },
        ],
    },
    ph: {
        email_title: 'Subscribe & get ₱500 Off coupon',
    },
    mx: {
        email_title: 'Suscríbete y obtén un cupón de MXN 200.',
    },
    jp: {
        email_title: 'メルマガ登録はこちら',
        email_desc: '新製品やセールなど、お得な最新情報をお届けするメルマガを購読して、5%OFF クーポンをゲットしよう！',
    },
    au: {
        email_title: 'Join now and earn EcoCredits for cash deductions, and stay tuned for exclusive Member prizes.',
    },
};

export default FooterLangTextA;
